import { render, staticRenderFns } from "./PricingPageAlert.vue?vue&type=template&id=1455560f&scoped=true&"
import script from "./PricingPageAlert.vue?vue&type=script&lang=js&"
export * from "./PricingPageAlert.vue?vue&type=script&lang=js&"
import style0 from "./PricingPageAlert.vue?vue&type=style&index=0&id=1455560f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455560f",
  null
  
)

export default component.exports